import styled from 'styled-components';

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
`;

export const TitleAndBreadcrumbWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Container = styled.div`
  padding: 16px 14px;
`;

export const Title = styled.span`
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 12px;
`;
